"use strict"

angular.module("informaApp")
    .service("IntercomService", ["$window", "BaseApiService", function ($window, BaseApiService) {
        function getAppId() {
            var appId = window.envVariables && 
                       window.envVariables.intercom && 
                       window.envVariables.intercom.intercomAppId;
            return appId || 'wchr1v1s';
        }

        function isIntercomLoaded() {
            return typeof $window.Intercom === 'function';
        }

        function buildUserPayload(user) {
            var intercomData = {
                app_id: getAppId(),
                api_base: "https://api-iam.intercom.io"
            };

            if (user) {
                intercomData.user_id = String(user.salesforceId || user.id);
                intercomData.email = user.email && user.email.toLowerCase();
                var fullName = '';
                if (user.firstName && user.lastName) {
                    fullName = user.firstName + ' ' + user.lastName;
                } else if (user.firstName) {
                    fullName = user.firstName;
                } else if (user.lastName) {
                    fullName = user.lastName;
                } else if (user.email) {
                    fullName = user.email;
                }
                intercomData.name = fullName;
            }

            return intercomData;
        }

        function bootLoggedInUser(intercomData) {
            BaseApiService.get('intercom/messenger-jwt')
                .then(function (res) {
                    var payload = res.data && res.data.data;
                    var jwtToken = payload && payload.intercom_user_jwt;

                    if (jwtToken) {
                        intercomData.intercom_user_jwt = jwtToken;
                        $window.Intercom('boot', intercomData);
                    } else {
                        console.warn('Intercom: messenger JWT missing in API response; not booting Messenger');
                    }
                })
                .catch(function (err) {
                    console.warn('Intercom: could not load messenger JWT', err);
                });
        }

        return {
            boot: function (user) {
                if (!isIntercomLoaded()) {
                    console.log('Intercom is not loaded yet');
                    return;
                }

                var intercomData = buildUserPayload(user);

                if (user) {
                    bootLoggedInUser(intercomData);
                } else {
                    $window.Intercom('boot', intercomData);
                }
            },

            update: function (data) {
                if (!isIntercomLoaded()) {
                    return;
                }

                $window.Intercom('update', data);
            },

            shutdown: function () {
                if (!isIntercomLoaded()) {
                    return;
                }

                $window.Intercom('shutdown');
            },

            show: function () {
                if (!isIntercomLoaded()) {
                    return;
                }

                $window.Intercom('show');
            },

            hide: function () {
                if (!isIntercomLoaded()) {
                    return;
                }

                $window.Intercom('hide');
            }
        };
    }]);
